import { loadable } from '@direct-frontend/modules-render';
import { DelayedSuspense } from '#shared/components/DelayedSuspense';
import { PageStub } from '#shared/components/PageStub';

const SettingsOtherLazy = loadable(() => import(/* webpackChunkName: "SettingsLight" */ './SettingsOtherSuspense'));

export const SettingsOtherAsync = () => (
    <DelayedSuspense fallback={<PageStub />}>
        <SettingsOtherLazy />
    </DelayedSuspense>
);
